import { REACT_QUERY_KEYS } from '@/constants'
import { type CustomersRequestQuery } from '@/libs/api/types'

export const customersQueryKeys = {
  all: [REACT_QUERY_KEYS.CUSTOMERS] as const,
  /** 荷主単体取得 (defaultAdditionalPaymentCategories を含む CustomerExEntity) */
  detail: (tenantKey: string, customerId: number) =>
    [...customersQueryKeys.all, 'detail', tenantKey, customerId] as const,
  select: (
    tenantKey: string,
    query: CustomersRequestQuery,
    shippingDate?: string
  ) =>
    [
      ...customersQueryKeys.all,
      'select',
      tenantKey,
      query,
      shippingDate
    ] as const
}
